import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowLeftRight, Gamepad2, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const VARIANTS = {
  p2p: {
    Icon: ArrowLeftRight,
    accent: '#14F195',
    title: 'P2P Trade',
    tagline: 'Coming Soon — Security Testing',
    body: 'Peer-to-peer trades handle real assets, so we are running a dedicated security programme before opening this to real users. Elimination is our first LIVE product; P2P follows once its custody model matches the same bar.',
  },
  elimination: {
    Icon: Gamepad2,
    accent: '#FF0055',
    title: 'Elimination Bot',
    tagline: 'Coming soon.',
    body: 'Improvements and final touches being polished.',
  },
};

const ComingSoon = ({ variant = 'p2p' }) => {
  const { Icon, accent, title, tagline, body } = VARIANTS[variant] || VARIANTS.p2p;

  return (
    <div
      className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6"
      data-testid={`coming-soon-${variant}`}
    >
      <div className="max-w-xl w-full text-center">
        <div
          className="w-20 h-20 mx-auto mb-8 rounded-2xl flex items-center justify-center"
          style={{
            background: `linear-gradient(135deg, ${accent}22, ${accent}05)`,
            border: `1px solid ${accent}55`,
            boxShadow: `0 0 40px ${accent}22`,
          }}
        >
          <Icon className="w-9 h-9" style={{ color: accent }} strokeWidth={1.5} />
        </div>

        <div className="flex items-center justify-center gap-2 mb-3">
          <Sparkles className="w-4 h-4" style={{ color: accent }} />
          <span
            className="text-xs uppercase tracking-[0.25em] font-medium"
            style={{ color: accent }}
          >
            {title}
          </span>
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
          {tagline}
        </h1>
        <p className="text-base sm:text-lg text-[#A1A1AA] mb-10">
          {body}
        </p>

        <Link to="/">
          <Button
            variant="outline"
            className="border-white/15 text-white hover:bg-white/5 rounded-full px-6"
            data-testid={`coming-soon-${variant}-back-btn`}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ComingSoon;
